import { executeRequest, Request, Response } from '@jfs/network'
import { convertBoolValue } from '../util/billPaymentUtil'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

export interface BillFetchInput {
  billerMasterId: number
  authenticators: Array<string>
}
interface ExtraInfo {
  value: string
  name: string
}

const whiteListErrorCodes = ['INV_MSG_065', 'INV_MSG_070']

export const returnExtraInfo = (extraInfo: Array<ExtraInfo>, id: number) => {
  if (extraInfo) {
    return extraInfo
      .filter((item) => item.value !== 'NA' && item.value !== null && item.value !== '')
      .map((item: ExtraInfo, index: number) => {
        return {
          ...item,
          id: `${id}_${index}`,
        }
      })
  }
  return []
}
const responseParser = (data: Response) => {
  const [item] = data?.data?.responseObject
  const billId = 9988
  const customerBill: any = item?.bill?.customerDetails ?? {}
  const bill: any = item?.bill
  const metaData: any = item?.bill?.metaData?.bpAuthenticator
  const attribute: any = item?.product?.attribute

  const billMetaDate = returnExtraInfo(metaData, billId)
  const producExtraInfo = returnExtraInfo(item?.product?.extraInfo, billId)

  const extraInfos = [...billMetaDate, ...producExtraInfo]

  const agentFeeAmount = metaData?.find((ele: any) => ele.name === 'Agent Fee Amount')
  const ret = {
    amount: item?.bill?.amountDetails?.amount ?? '10000',
    txnMetaData: {
      bill: {
        id: ([...attribute?.authenticatorList] ?? []).toString(),
        amount: item?.bill?.amountDetails?.amount ?? '',
        agentFeeAmount: agentFeeAmount?.value ?? '',
        operatorId: item?.product?.id,
        amountAfterDueDate: item?.bill?.amountAfterDueDate ?? 'NA',
        billerMasterId: item?.product?.id,
        date: customerBill.billDate ?? '',
        dueDate: bill?.dueDate ?? '',
        billNumber: bill?.number ?? '',
        authenticators: [...attribute?.authenticatorList],
        labelOfAuthenticators: attribute?.labelOfAuthenticators,
        status: item?.payment?.status ?? '',
        customerBillDataId: customerBill.customerBillDataId ?? 0,
        customerBillerAccountId: customerBill.customerBillerAccountId ?? 0,
        shortName: item?.product?.displayName,
        alertFlag: convertBoolValue(item?.bill?.paymentAllowed),
        alertMessage: item?.bill?.remarks ?? '',
        ebppBillerMasterId: item?.product?.ebppBillerMasterId ?? 0,
        proceedPaymentFlag: convertBoolValue(item?.product?.proceedPaymentFlag),
        proceedPaymentAlertMsg: item?.product?.proceedPaymentAlertMsg ?? '',
        physicalBillUrl: customerBill?.physicalBillUrl ?? '',
        existingBillerFlag: convertBoolValue(item?.product?.existingBillerFlag),
        extraInfos: extraInfos,
        period: item?.product?.billPeriod ?? '',
        siStatus: convertBoolValue(item?.standingInstruction?.siStatus),
        customerName: item?.customerDetails?.name ? item?.customerDetails?.name : item?.product?.customerName ?? '',
        scheduledDebitDate: customerBill.billScheduledDebitDate ?? '',
        lastPaymentGreaterThanBillCreatedDate: null,
        createdDate: '',
        lastPaidDate: '',
        beneficiaryId: item?.beneficiary?.id,
        circleId: 0,
        circleName: '',
        billPresentConsent: convertBoolValue(item?.product?.billPresentConsent),
        billPresentConsentDisplay: convertBoolValue(item?.product?.billPresentConsentDisplay),
        lastTxnRefNo: customerBill?.lastTxnRefNo ?? '',
        type: customerBill?.billerType ?? '',
        customerAccountId: Number(item?.customerDetails?.id) ?? 0,
        partialPaymentAllow: convertBoolValue(item?.product?.partialPaymentAllow),
      },
    },
  }
  if (ret.txnMetaData.bill.alertFlag) {
    const errorMsg = {
      errorMessage: ret.txnMetaData.bill.alertMessage,
    }
    throw errorMsg
  }
  return ret
}

export const getBillFetch = (tokens, userAccessToken, values: any) => {
  const config = sitConfig(tokens)
  //config.baseUrl = Config.REACT_APP_JFS_BASE_URL
  const request: Request<{}> = {
    apiPath: APIEndPoints.getBillFetch,
    method: 'POST',
    body: values,
    config: config,
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
    //headers: { ...getHeader() },
  }

  return executeRequest(request).then((data) => {
    if (data?.data?.responseStatus?.code === '000') {
      return responseParser(data)
    }
    const errorMsg = {
      errorCode: data?.data?.error?.code,
      errorMessage: data?.data?.error?.message,
    }

    throw errorMsg
  })
}
